import {Modal} from 'antd'
import runAsync from '@/script/runAsync.mjs'

export const checkSyntax = () => () => {
    return async function () {
        await runAsync(
            () => this.syntax.check(),
            {action: '规范性检测'}
        )

        const {errors, message} = this.syntax.report

        if (0 < errors.length) {
            this.openSidePanel('left', 'syntax')
        }
        else {
            Modal.success({content: message})
        }
    }
}
